import { SshKeyListV4200RowsItem } from '@newfold/huapi-js/src/index.schemas';

import { SSHKey } from '~/components/SSHKeysTable';

// Get the default key name based on existing keys
const BASE_NAME = 'id_rsa';
const SUFFIX_RE = /^id_rsa(\d+)(\.pub)?$/;

export const getDefaultKeyName = (keys: SSHKey[]): string => {
  let maxSuffix = -1;
  for (const { name } of keys) {
    if (!name) continue;
    if (name === BASE_NAME || name === `${BASE_NAME}.pub`) {
      maxSuffix = Math.max(maxSuffix, 0);
    }
    const match = name.match(SUFFIX_RE);
    if (match) {
      maxSuffix = Math.max(maxSuffix, Number(match[1]));
    }
  }
  return maxSuffix < 0 ? BASE_NAME : `${BASE_NAME}${maxSuffix + 1}`;
};

export const getAlgorithmType = ({
  alg_type,
  type,
}: SshKeyListV4200RowsItem) => {
  return (alg_type || type || '-').toUpperCase();
};
